import z from 'zod';
import { AllCharLabelSchema, UnixTimestampSchema, UUIDSchema } from '../common/schemas';
import { DBTimestampSchema } from '../common/sql';

/**
 * DB Schemas
 */

export const DBInstitutionIdSchema = UUIDSchema;
export const DBInstitutionKeySchema = z
  .string()
  .min(1)
  .max(128)
  .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'Must be a lowercase hyphenated slug');
export const DBInstitutionNameSchema = AllCharLabelSchema.min(1).max(256);
export const DBInstitutionSearchNameSchema = z
  .string()
  .min(1)
  .max(256)
  .regex(/^[a-z0-9]+$/, 'Must be letters and digits only');
export const DBInstitutionShortNameSchema = AllCharLabelSchema.min(1).max(64).nullable();
export const DBInstitutionAbbreviationSchema = AllCharLabelSchema.min(1).max(64).nullable();

export const DBInstitutionSchema = z.object({
  id: DBInstitutionIdSchema,
  key: DBInstitutionKeySchema,
  name: DBInstitutionNameSchema,
  searchName: DBInstitutionSearchNameSchema,
  shortName: DBInstitutionShortNameSchema,
  abbreviation: DBInstitutionAbbreviationSchema,
  kindId: UUIDSchema,
  schoolId: z.string().min(1).max(64).nullable(),
  suburb: AllCharLabelSchema.min(1).max(128).nullable(),
  state: AllCharLabelSchema.min(1).max(64).nullable(),
  postcode: z.string().min(1).max(16).nullable(),
  country: AllCharLabelSchema.min(1).max(64).nullable(),
  isActive: z.boolean(),
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

/**
 * Client Schemas
 */

export const InstitutionIdSchema = UUIDSchema;
export const InstitutionKeySchema = DBInstitutionKeySchema.openapi({
  description: 'Stable key that reference data and code use to name the institution',
  example: 'sydney-grammar-school',
});
export const InstitutionNameSchema = DBInstitutionNameSchema;
export const InstitutionSearchNameSchema = DBInstitutionSearchNameSchema;
export const InstitutionShortNameSchema = DBInstitutionShortNameSchema;
export const InstitutionAbbreviationSchema = DBInstitutionAbbreviationSchema.openapi({
  description: 'Common abbreviation of the name, as papers print it',
  example: 'NSB',
});

export const InstitutionSchema = z.object({
  id: InstitutionIdSchema,
  key: InstitutionKeySchema,
  name: InstitutionNameSchema,
  searchName: InstitutionSearchNameSchema,
  shortName: InstitutionShortNameSchema,
  abbreviation: InstitutionAbbreviationSchema,
  kindId: UUIDSchema,
  schoolId: z.string().min(1).max(64).nullable(),
  suburb: AllCharLabelSchema.min(1).max(128).nullable(),
  state: AllCharLabelSchema.min(1).max(64).nullable(),
  postcode: z.string().min(1).max(16).nullable(),
  country: AllCharLabelSchema.min(1).max(64).nullable(),
  isActive: z.boolean(),
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});
